/* eslint-disable react-hooks/rules-of-hooks */
import React from 'react';
import './toimipisteet.css';
import imJp from '../../images/jpaa-kuva.jpg';
import rehtori from '../../images/Sauli.jpg';
import varaRehtori from '../../images/jp.JPG';
import jarvenpaatalo from '../../images/jarvenpaaTalo.jpg';
import Taina from '../../images/Taina2.jpg';
import Helmet from 'react-helmet';
import Monio from '../../images/monio2.jpeg';

export default function OwnMap() {
  const ToimiYhteys = () => {
    return (
      <div className="map-buttons container">
        <br />
        <div style={{ height: "auto" }} className="map-buttons">
          <div className="map-flex" style={{ marginBottom: "7%" }}>
            <h4></h4>

            {/* TOIMIPISTEET */}
            <div className="toimisto">
              <div className="card" style={{ backgroundColor: "white" }}>
                <img src={imJp} width="100%" alt="kum-toimpiste-järvenpää" />
                <div className="rehtori-own" style={{ backgroundColor: "white" }}>
                  <h3>Järvenpään toimipiste / </h3>
                  <p>Seutulantie 8</p>
                  <a target="_blank" rel="noreferrer" href="https://goo.gl/maps/JG7DoVyJS1msZXzy9">
                    Katso kartalta
                  </a>
                </div>
              </div>

              <div className="card" style={{ backgroundColor: "white", border: "none" }}>
                <img src={Monio} alt="kum-toimpiste-tuusula" width="100%" />
                <div className="rehtori-own" style={{ backgroundColor: "white" }}>
                  <h3>Tuusulan toimipiste / </h3>
                  <p>Pataljoonantie 6</p>
                  <a target="_blank" rel="noreferrer" href="https://goo.gl/maps/XhS2kSY2cC4bcJHo7">
                    Katso kartalta
                  </a>
                </div>
              </div>

              <div className="card" style={{ backgroundColor: "white" }}>
                <img src={jarvenpaatalo} width="100%" alt="kum-toimpiste-jarvenpaa-talo" />
                <div className="rehtori-own" style={{ backgroundColor: "white" }}>
                  <h3>Järvenpää-talon toimipiste / </h3>
                  <p>Hallintokatu 4</p>
                  <a target="_blank" rel="noreferrer" href="https://goo.gl/maps/zPm4t7TDdPswENyf8">
                    Katso kartalta
                  </a>
                </div>
              </div>
            </div>

            <h5 style={{ textAlign: "center", fontSize: "16px", fontWeight: "400" }}>
              * Lisäksi musiikkiopisto toimii monilla alueen kouluilla ja päiväkodeilla
            </h5>
          </div>

          {/* TOIMISTO TIEDOT */}
          <div className="toimisto-all">
            <div className="toimisto-allText">
              <h3>Toimisto</h3>

              <p>Oppilasasiat, lukukausimaksut</p>
              <p>Keskisen Uudenmaan Musiikkiopisto</p>
              <p>Seutulantie 8, 04410 Järvenpää (2. krs)</p>
              <p>Pataljoonantie 6, 04300 Tuusula  (1.krs)</p>
              <p>puh. 040 315 2803</p>
              <a href="mailto:musiikkiopisto(at)jarvenpaa.fi">musiikkiopisto(at)jarvenpaa.fi</a>

              <br />
              <br />

              <h3>Toimiston puhelin- ja palveluajat:</h3>
              <p>ma klo 13.30-15.30 Järvenpää</p>
              <p>ti klo 13.30-15.30 Tuusula</p>
              <p>to klo 13.30-15.30 Järvenpää</p>
              <br />

              <p>
                <strong>Loma-aikoina ei palveluaikoja, sovi tapaaminen etukäteen. </strong>
              </p>
            </div>
          </div>

          <br />
          <br />

          {/* HENKILÖKUNTA KORTIT */}
          <div className="toimisto">
            <div className="card staff-card">
              <img className="staff-img" src={rehtori} alt="Kum Sauli Tyni" />
              <div className="rehtori-own">
                <h3>Rehtori Sauli Tyni</h3>
                <p>puh. 040 315 2845</p>
                <p>sauli.tyni(at)jarvenpaa.fi </p>
                <p>Sovi tapaamisaika etukäteen.</p>
              </div>
            </div>

            <div className="card staff-card">
              <img className="staff-img" src={varaRehtori} alt="Kum-Juha-Pekka-Putkonen" />
              <div className="rehtori-own">
                <h3>Apulaisrehtori Juha-Pekka Putkonen</h3>
                <p>puh. 040 315 2864</p>
                <p>juha-pekka.putkonen(at)jarvenpaa.fi</p>
                <p>Sovi tapaamisaika etukäteen.</p>
              </div>
            </div>

            <div className="card staff-card">
              <img className="staff-img" src={Taina} alt="Kum-Taina-Perttilä" />
              <div className="rehtori-own">
                <h3>Opintosihteeri Taina Perttilä </h3>
                <p>puh. 040 315 2803</p>
                <p>taina.perttila(at)jarvenpaa.fi</p>
                <p>Toimiston palveluajat.</p>
              </div>
            </div>
          </div>
        </div>
        <br />
      </div>
    );
  };

  return (
    <div className="toimipisteet">
      <Helmet>
        <title>Toimipisteet ja yhteystiedot</title>
        <meta
          name="description"
          content="Keskisen uudenmaan musiikkiopiston yhteystiedot toimipisteet ja opettajat. Rehtori Pirre Raijas. Apulaisrehtori Juha-Pekka Putkonen "
        ></meta>
        <link rel="canonical" href="http://kum.fi/toimipisteet"></link>
      </Helmet>

      <div style={{ textAlign: 'center' }}>
        <div className="yhteyis-hinnasto" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '10px' }}>
          <i className="fas fa-location-arrow" style={{ fontSize: '40px' }}>
            <span>
              <i className="fa fa-address-book" aria-hidden="true"></i>
            </span>
          </i>
        </div>
        <h2>Toimipisteet / Yhteystiedot</h2>
      </div>

      <ToimiYhteys />
    </div>
  );
}